<template>
  <div class="full-height">
    <Row
      type="flex"
      justify="space-between"
      align="middle"
      class="s2ec-page-actions"
    >
      <i-col
        :xs="24"
        :md="16"
      >
        <Button
          class="action-button"
          @click="openEditInfo"
        >
          {{ $t("Edit profile") }}
        </Button>
        <router-link :to="{ name: 'notification-settings' }">
          <Button
            class="action-button"
            style="margin-left: 8px"
          >
            {{ $t("Notification preferences") }}
          </Button>
        </router-link>
      </i-col>
      <PersonalInfo
        ref="personalInfo"
        v-model="editInfo"
        @infoUpdated="info = $event"
      />
    </Row>
    <Row
      type="flex"
      :gutter="10"
    >
      <i-col
        :xs="24"
        :sm="24"
        :md="10"
        :lg="10"
      >
        <Card
          class="cards"
          style="height: 320px"
        >
          <Spin
            v-if="loading"
            fix
          />
          <div class="cardTitle">
            <Icon
              type="ios-person"
              size="30"
              color="var(--primary-color)"
            />
            <span class="text-title">{{ $t("Personal information") }}</span>
          </div>
          <div class="card-content">
            <p>
              <span>{{ $t("First name") }}: </span>
              <span>{{ info.first_name }}</span>
            </p>
            <p>
              <span>{{ $t("Last name") }}: </span>
              <span>{{ info.last_name }}</span>
            </p>
            <p>
              <span>{{ $t("Cellphone") }}: </span>
              <span>{{ info.cellphone }}</span>
            </p>
          </div>
        </Card>
      </i-col>
      <i-col
        :xs="24"
        :sm="24"
        :md="10"
        :lg="10"
      >
        <Spin
          v-if="loading"
          fix
        />
        <Card
          class="cards"
          style="height: 320px"
        >
          <div class="cardTitle">
            <img src="../../assets/images/ico/account_info.png">
            <span class="text-title">{{ $t("Account information") }}</span>
          </div>
          <div class="card-content">
            <p>
              <span>{{ $t("Email address") }}: </span>
              <span>{{ info.email }}</span>
            </p>
            <p>
              <span>{{ $t("Role") }}: </span>
              <span>{{ $t(info.user_role_display) }}</span>
            </p>
            <p>
              <span>{{ $t("Client") }}: </span>
              <span>{{ client_name }}</span>
            </p>
            <p>
              <span>{{ $t("Contract(s)") }}: </span>
              <span>{{ info.contracts_names.join(", ") }}</span>
            </p>
          </div>
        </Card>
      </i-col>
    </Row>
  </div>
</template>

<script>
import PersonalInfo from "./modals/EditProfile";
import { getAccount } from "@/services/auth.service";
import { getClientQry } from "@/services/accounts.service";
import { mapState, mapActions } from "vuex";
import { updateAuthSessionByKeys } from "@/helpers/auth.helper";

export default {
  name: "Profile",
  components: {
    PersonalInfo,
  },
  data() {
    return {
      editInfo: false,
      editAvatarInfo: false,
      client_name: "",
      info: {
        avatar: null,
        cellphone: null,
        address: null,
        city: null,
        country: null,
        country_name: null,
        first_name: null,
        last_name: null,
        email: null,
        client: null,
        user_role_display: null,
        contracts_names: [],
      },
      lastUpdate: null,
      loading: false,
      imageLoading: false,
    };
  },
  computed: {
    _NOPE__currentAvatar() {
      if (typeof this.info.avatar === "string") {
        return this.info.avatar;
      } else {
        return this.avatar;
      }
    },
  },
  created() {
    this.loadInfo();
  },
  methods: {
    ...mapActions({ setUserProfile: "userDetail/setUserProfile" }),
    openEditInfo() {
      this.$refs.personalInfo.setFormData(this.info, this.lastUpdate);
      this.editInfo = true;
    },
    openAvaterInfo() {
      this.$refs.avaterInfo.setFormData(this.info, this.lastUpdate);
      this.editAvatarInfo = true;
    },
    loadInfo() {
      const self = this;
      self.loading = true;
      getAccount()
        .then((response) => {
          self.info = { ...response.data };
          getClientQry(response.data.client).then((res) => {
            this.client_name = res.data.client_name;
          });
          self.lastUpdate = response.data.updated_at;
          self.loading = false;
        })
        .catch((err) => {
          self.loading = false;
        });
    },
  
  },
};
</script>

<style scoped>
.profile .cards {
  margin: 15px 15px 15px 0px;
  background: white;
}

.cardTitle {
  text-align: left;
  font-size: 15px;
  padding-left: 10px;
  padding-bottom: 15px;
  display: flex;
  align-items: center;
}

.card-content {
  letter-spacing: 1px;
  padding-left: 50px;
  line-height: 28px;
}
.cardTitle .text-title {
  padding-left: 10px;
}
</style>
